
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/staking/lido/stake",
      function () {
        return require("private-next-pages/staking/lido/stake.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/staking/lido/stake"])
      });
    }
  